import React from 'react';

// components
import ActivitiesPanel from './components/ActivitiesPanel';
import BriefPanel from './components/BriefPanel';
import CommTabs from './components/CommTabs';
import CommunicationsPanel from './components/CommunicationsPanel';

// store
import { CommCenterProvider, useCommCenter } from './context';

const CommCenterInner = () => {
    const { activeTab } = useCommCenter();

    return (
        <div className="appCommCenter">
            <CommTabs/>
            {activeTab === 'activities' && <ActivitiesPanel/>}
            {activeTab === 'communications' && <CommunicationsPanel/>}
            {activeTab === 'brief' && <BriefPanel/>}
        </div>
    )
}

/**
 * Project scoped Comm Center: Attività, Comunicazioni and — on the project page
 * — Brief. Used by the single project page and by My Studio.
 *
 * @param {string}  props.cueTarget      'cuesheet' | 'timeline' | 'studio'
 * @param {string}  props.projectId      project the sidebar belongs to
 * @param {boolean} props.hasBrief       render the Brief tab
 * @param {object}  props.briefFallback  stand-in project for previews
 */
const CommCenter = ({ cueTarget, projectId, hasBrief, briefFallback }) => {
    return (
        <CommCenterProvider
            cueTarget={cueTarget}
            projectId={projectId}
            scope="project"
            hasBrief={hasBrief}
            briefFallback={briefFallback}>
            <CommCenterInner/>
        </CommCenterProvider>
    )
}

export default CommCenter;
